import { Box, FormGroup } from '@material-ui/core'
import { SelectField } from 'components/Common/Form/Fields/SelectField'
import { SimpleTextField } from 'components/Common/Form/Fields/SimpleTextField'
import { ToggleField } from 'components/Common/Form/Fields/ToggleField'
import { Control, UseFormResetField, UseFormWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { PartyItem } from '../PartiesPages'

type FormPartiesProps = {
  defaultValues: PartyItem
  control: Control<PartyItem>
  resetField: UseFormResetField<PartyItem>
  watch: UseFormWatch<PartyItem>
}

export const FormParties = ({
  control,
  resetField,
  defaultValues,
  watch,
}: FormPartiesProps) => {
  const { t } = useTranslation()

  const isHasSubscriptionTrue = watch('hasSubscription')

  const currencyOptions = [
    {
      label: 'EUR',
      value: 'EUR',
    },
    {
      label: 'GBP',
      value: 'GBP',
    },
  ]
  return (
    <Box
      component="div"
      style={{
        width: '60vw',
        maxWidth: '500px',
      }}
    >
      <FormGroup
        aria-label="position"
        row
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        <SimpleTextField
          control={control}
          name="id"
          disabled={!!defaultValues.id}
          onEscPress={() => resetField('id')}
          label={t('common:party-id', 'Party Id')}
          defaultValue={defaultValues.id}
        />

        <SimpleTextField
          control={control}
          name="name"
          onEscPress={() => resetField('name')}
          label={t('common:name', 'Name')}
          defaultValue={defaultValues.name}
        />

        <SimpleTextField
          control={control}
          name="coCKey"
          onEscPress={() => resetField('coCKey')}
          label={t('common:coCKey', 'coCKey')}
          defaultValue={defaultValues.coCKey}
        />

        <SelectField
          disabled={!!defaultValues.id}
          control={control}
          name="currencyCode"
          onEscPress={() => resetField('currencyCode')}
          label={t('settings:currency-code', 'currency code')}
          defaultValue={defaultValues.currencyCode || 'EUR'}
          options={currencyOptions}
        />

        <Box display="flex" justifyContent="space-around">
          <ToggleField
            control={control}
            name="hasSubscription"
            defaultValue={defaultValues.hasSubscription}
            label={t('common:has-subscription', 'has subscription')}
            onEscPress={() => resetField('hasSubscription')}
          />
          <ToggleField
            control={control}
            disabled={!isHasSubscriptionTrue}
            name="hasSelfSevicePortal"
            defaultValue={defaultValues.hasSelfSevicePortal}
            label={t(
              'common:has-self-service-portal',
              'has self sevice portal'
            )}
            onEscPress={() => resetField('hasSelfSevicePortal')}
          />
        </Box>
      </FormGroup>
    </Box>
  )
}
